import { c as _c } from "react/compiler-runtime";
import { useCollapsibleTextItem } from "@website/ui/collapsible-text/collapsible-text.hook";
import styles from "@website/ui/collapsible-text/collapsible-text.module.scss";
import { CollapsibleTextPropertiesType } from "@website/ui/collapsible-text/collapsible-text.types";
import { FC } from "react";
export const CollapsibleText: FC<CollapsibleTextPropertiesType> = properties => {
  const $ = _c(29);
  const {
    regionProperties,
    descriptionProperties,
    collapsed,
    buttonProperties,
    collapsible
  } = useCollapsibleTextItem(properties);
  const {
    className,
    buttonClassName,
    direction,
    title,
    moreText,
    lessText,
    titleStyle,
    moreTextIcon,
    lessTextIcon,
    withMedia,
    collapsedClassName,
    disableScrollWhenCollapsed: t0,
    isHtml: t1
  } = properties;
  const disableScrollWhenCollapsed = t0 === undefined ? false : t0;
  const isHtml = t1 === undefined ? false : t1;
  const t2 = `${styles.item} ${withMedia ? styles["with-media"] : ""}`;
  let t3;
  if ($[0] !== title || $[1] !== titleStyle) {
    t3 = title && <h2 className={`${titleStyle ?? styles.title}`}>{title}</h2>;
    $[0] = title;
    $[1] = titleStyle;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = `${collapsedClassName} ${styles.content}`;
  let t5;
  if ($[3] !== className || $[4] !== collapsed || $[5] !== descriptionProperties || $[6] !== disableScrollWhenCollapsed || $[7] !== isHtml) {
    t5 = isHtml ? <div className={`${styles.description} ${className} ${collapsed && disableScrollWhenCollapsed ? "overflow-hidden" : ""}`} dangerouslySetInnerHTML={{
      __html: String(descriptionProperties?.children)
    }} /> : <div {...descriptionProperties} className={`${styles.description} ${className}`} />;
    $[3] = className;
    $[4] = collapsed;
    $[5] = descriptionProperties;
    $[6] = disableScrollWhenCollapsed;
    $[7] = isHtml;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== direction || $[10] !== regionProperties || $[11] !== t4 || $[12] !== t5) {
    t6 = <div {...regionProperties} className={t4} dir={direction}>{t5}</div>;
    $[9] = direction;
    $[10] = regionProperties;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = !collapsible;
  const t8 = `${styles.button} ${buttonClassName}`;
  const t9 = collapsed ? moreText || "\u0646\u0645\u0627\u06CC\u0634 \u0628\u06CC\u0634\u062A\u0631" : lessText || "\u0646\u0645\u0627\u06CC\u0634 \u06A9\u0645\u062A\u0631";
  let t10;
  if ($[14] !== t9) {
    t10 = <span className={styles.button__txt}>{t9}</span>;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = collapsed ? moreTextIcon : lessTextIcon;
  let t12;
  if ($[16] !== t11) {
    t12 = <span>{t11}</span>;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== buttonProperties || $[19] !== t10 || $[20] !== t12 || $[21] !== t7 || $[22] !== t8) {
    t13 = <button hidden={t7} {...buttonProperties} className={t8}>{t10}{t12}</button>;
    $[18] = buttonProperties;
    $[19] = t10;
    $[20] = t12;
    $[21] = t7;
    $[22] = t8;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t13 || $[25] !== t2 || $[26] !== t3 || $[27] !== t6) {
    t14 = <div className={t2}>{t3}{t6}{t13}</div>;
    $[24] = t13;
    $[25] = t2;
    $[26] = t3;
    $[27] = t6;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  return t14;
};